import { render, staticRenderFns } from "./Bold-Dashboard.vue?vue&type=template&id=f27949e2&scoped=true"
import script from "./Bold-Dashboard.vue?vue&type=script&lang=js"
export * from "./Bold-Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Bold-Dashboard.vue?vue&type=style&index=0&id=f27949e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27949e2",
  null
  
)

export default component.exports